export default {
  leastDrawn: 'Ən az çıxan',
  mostDrawn: 'Ən çox çıxan',
  leastPlayed: 'Ən az oynanılan',
  mostPlayed: 'Ən çox oynanılan',
  drawFrom: 'Tiraj mənbəyi',
  h: 's', // qısa: saat
  startingIn: 'Başlayır',
  waitingForDrawnFrom: 'Tirajın başlanması gözlənilir',
  displayingDrawFrom: 'Tiraj göstərilir',
  lotteryDraw: 'Lotereya tirajı',
  eventId: 'Hadisə ID',
  bettingShortcuts: 'Mərc qısayolları',
  draw: 'Tiraj',
  next5Events: 'Növbəti {value} göstərilir',
  events: 'Hadisələr',
  schedule: 'Cədvəl',
  next: 'Növbəti',
  event: 'Hadisə',
  later: 'Sonra',
  statistics: 'Statistika',
  lastnRounds: 'Son {value} tiraj',
  bettingOffer: 'Mərc təklifi',
  notDisplayed: 'Göstərilmir',
  latestResults: 'Son nəticələr',
  drawnAt: '{value} tarixində tiraj edildi',
  additionalBetting: 'Əlavə mərc',
  drawSumEvenOdd: 'Tiraj cəmi cüt və ya tək',
  drawSumTotal: 'Tiraj cəmi',
  drawSumRange: 'Tiraj cəmi diapazonu',
  waitingForDrawNo: '{value} nömrəli tiraj gözlənilir',
  nextDraw: 'Növbəti tiraj',
  waitingForDraw: 'Tiraj gözlənilir',
  drawCompleted: 'Tiraj tamamlandı',
  drawDisplayTemporarilyNotAvailable: 'Tiraj görüntüsü müvəqqəti mövcud deyil',
  connectionError: 'Bağlantı xətası!',
  reconnecting: 'Yenidən qoşulur...',
  number: 'Nömrə',
  headerNumberDescriptionUp: 'Hadisə',
  headerNumberDescriptionDown: 'Nömrə',
};
